import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

/**
 * Renders the root of the application, providing theme and color context.
 *
 * @component
 * @returns {JSX.Element} Root component of the application.
 */
function Root() {

  return (
    <React.StrictMode>
          <App/>
    </React.StrictMode>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Root />);